import React from 'react';
import PropTypes from 'prop-types';

import SelectableRow from 'components/selectable_record_table/selectable_row';

const CLASS_BY_STATUS = {
  'received': 'table-info',
  'error': 'table-danger',
  'success': 'table-success',
};

export default class WebhookEventRow extends React.Component {
  static propTypes = {
    webhookEvent: PropTypes.shape({
      createdAtFormatted: PropTypes.string.isRequired,
      eventType: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      identifier: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    })
  };

  statusClass() {
    return CLASS_BY_STATUS[this.props.webhookEvent.status] || 'table-warning';
  }

  render() {
    const { createdAtFormatted, eventType, id, identifier, status } = this.props.webhookEvent;

    return (
      <SelectableRow hideCheckbox={true}>
        <td>{id}</td>
        <td>{identifier}</td>
        <td className={this.statusClass()}>{status}</td>
        <td>{eventType}</td>
        <td>{createdAtFormatted}</td>
        <td><a href={`/corporate/webhook_events/${id}`}>Details</a></td>
      </SelectableRow>
    );
  }
}
